/* Expected delivery for a configured build: shared by the Bike Studio and
   the Crank Builder.

   Each product carries its own delivery estimate in the metafield
   custom.tiempo_entrega_estimado, as free text written by the shop
   ("20 a 30 días laborables", "2 - 5 días plazo entrega", "Entre 30 y 40 días
   laborables.", "PRE ORDER: Plazo de entrega de 20 a 40 días laborables",
   "Primeras unidades final de septiembre"...). A build ships when its slowest
   part arrives, so the build's estimate is the part whose range reaches
   highest. Text with a day range is read as that range and shown in the
   reader's language; text without one (a date, a note) cannot be compared,
   so it is taken as the longest and shown as written. Parts with no value
   are left out.

   Values are read live through the product.leadtime alternate template
   (/products/<handle>?view=leadtime), so an edit to the metafield shows at
   once in both builders. Plain ES5 so both builders can load it. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.RaceitLeadTime = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var DAY = /(d[ií]as?|days?|werktag(?:e|en)?|tag(?:e|en)?|giorni|giorno|jours?|gg\.?)(?![a-z])/i;
  var WORKING = /(laborab|h[aá]biles|working|business|werktag|arbeitstag|lavorativ|ferial|ouvr[ée]|ouvrab)/i;
  var PRE = /(pre[\s-]?order|pre[\s-]?venta|preventa|reserva|vorbestell|pr[ée]commande|pre[\s-]?ordine)/i;
  // [working days, days, heading, short heading, pre-order, "set by"]
  var WORDS = {
    es: ['días laborables', 'días', 'Entrega estimada', 'Entrega', 'Pre-order', 'Plazo marcado por'],
    en: ['working days', 'days', 'Estimated delivery', 'Delivery', 'Pre-order', 'Set by'],
    de: ['Werktage', 'Tage', 'Voraussichtliche Lieferung', 'Lieferung', 'Vorbestellung', 'Bestimmt durch'],
    it: ['giorni lavorativi', 'giorni', 'Consegna stimata', 'Consegna', 'Pre-ordine', 'Determinata da'],
    fr: ['jours ouvrés', 'jours', 'Livraison estimée', 'Livraison', 'Précommande', 'Déterminée par']
  };
  var cache = {};

  function parse(text) {
    var t = String(text == null ? '' : text).replace(/\s+/g, ' ').trim();
    if (!t) return null;
    var pre = PRE.test(t);
    var nums = (t.match(/\d+/g) || []).map(Number);
    if (nums.length >= 1 && nums.length <= 2 && DAY.test(t)) {
      return { text: t, min: Math.min.apply(null, nums), max: Math.max.apply(null, nums), working: WORKING.test(t), pre: pre, verbatim: false };
    }
    return { text: t, min: null, max: null, working: false, pre: pre, verbatim: true };
  }

  // items: [{ handle, label, lead }] -> the item that sets the build's delivery
  function slowest(items) {
    var known = (items || []).filter(function (i) { return i && i.lead; });
    if (!known.length) return null;
    for (var k = 0; k < known.length; k++) if (known[k].lead.verbatim) return known[k];
    return known.reduce(function (a, b) {
      return (b.lead.max > a.lead.max || (b.lead.max === a.lead.max && b.lead.min > a.lead.min)) ? b : a;
    });
  }

  function words(lang) { return WORDS[lang] || WORDS.es; }

  // "30–40 días laborables" in the reader's language; a note stays as written.
  function format(lead, lang) {
    if (!lead) return '';
    if (lead.verbatim) return lead.text;
    var w = words(lang), range = lead.min === lead.max ? String(lead.max) : lead.min + '–' + lead.max;
    return range + ' ' + (lead.working ? w[0] : w[1]) + (lead.pre ? ' · ' + w[4] : '');
  }

  function load(handle, base) {
    var key = (base || '/') + '|' + handle;
    if (cache[key]) return cache[key];
    var url = (base || '/') + 'products/' + encodeURIComponent(handle) + '?view=leadtime';
    // No Accept: application/json header: with it Shopify answers with the
    // product's own JSON and ignores ?view=, so the template never runs.
    cache[key] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (body) {
        if (!body) return null;
        try { return parse(JSON.parse(body).leadTime); } catch (e) { return null; }
      })
      .catch(function () { delete cache[key]; return null; });
    return cache[key];
  }

  // items: [{ handle, label }] -> Promise<{ slowest, items }>
  function forBuild(items, base) {
    var list = (items || []).filter(function (i) { return i && i.handle; });
    return Promise.all(list.map(function (i) { return load(i.handle, base); })).then(function (leads) {
      var withLead = list.map(function (i, k) { return { handle: i.handle, label: i.label, lead: leads[k] }; });
      return { slowest: slowest(withLead), items: withLead };
    });
  }

  return { parse: parse, slowest: slowest, format: format, words: words, load: load, forBuild: forBuild };
});
